import { useStore } from "@nanostores/react";
import { ArrowSquareOut, X } from "@phosphor-icons/react";
import { useState } from "react";

import { useTranslations } from "@/i18n/utils";

import { closePlayer, trackReproduced } from "@/stores/player/playerStore";

import Paragraph from "@/components/shared/text/paragraph";
import TrackLinks from "../track/track-links/TrackLinks";
import TrackLinksModal from "../track/track-links/TrackLinksModal";

export const PlayerSocialMedia = ({ lang }: { lang: "es" | "en" }) => {
  const [modal, setModal] = useState(false);
  const track = useStore(trackReproduced);
  const t = useTranslations(lang);
  if (!track) return null;

  return (
    <div className="ml-4 flex items-center justify-end gap-x-4 md:ml-0 md:gap-x-10">
      {track.TrackLink.length > 0 && (
        <>
          <div className="hidden items-center gap-x-5 sm:flex">
            <Paragraph size="sm" className="text-white">
              {t("publicProfile.player.listenOn.desktop")}
            </Paragraph>
            <TrackLinks
              trackLink={track.TrackLink}
              lang={lang}
              maxTrack={2}
              numberToShow={2}
            />
          </div>

          <ArrowSquareOut
            role="button"
            className="sm:hidden"
            size={20}
            color="white"
            onClick={() => setModal(true)}
          />
        </>
      )}
      <X
        role="button"
        size={24}
        className="cursor-pointer rounded-full bg-white-10 p-1 text-white"
        onClick={() => closePlayer()}
      />
      <TrackLinksModal
        modal={modal}
        setModal={setModal}
        translation={t}
        trackLink={track.TrackLink}
      />
    </div>
  );
};
